import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/index/index.vue'
import store from '@/store'
const routes = [
  {
    path: '/404',
    component: () => import('../views/NextView/404')
  },
  {
    path: '/:pathMatch(.*)',
    redirect: '/404'
  },
  {
    path: '/',
    name: '买家',
    component: HomeView,
    meta: {
      IsLog: false,
      showNav: true
    }
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/index/login'),
    meta: {
      IsLog: false,
      showFooter: false
    }
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('../views/index/register'),
    meta: {
      IsLog: false,
      showFooter: false,
      showBgi: true
    }
  },
  {
    path: '/memberCenter',
    name: '个人中心',
    component: () => import('../views/member/index'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/memberEdit',
    name: '修改资料',
    component: () => import('../views/member/editUser'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/store',
    name: '加購資金',
    component: () => import('../views/member/store'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/withdraw',
    name: '盈餘結算',
    component: () => import('../views/member/withdraw'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/record_store',
    name: '結算明細',
    component: () => import('../views/member/record_store'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/record_withdraw',
    name: '結算明細2',
    component: () => import('../views/member/record_withdraw'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/proList',
    name: '產品分類',
    component: () => import('../views/member/proList'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/productList',
    name: '產品列表',
    component: () => import('../views/member/productList'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/productDetail',
    name: '產品詳情',
    component: () => import('../views/member/productDetail'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/proOEM',
    name: '家庭代工',
    component: () => import('../views/member/proOEM'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  },
  {
    path: '/bindBank',
    name: '绑定银行卡',
    component: () => import('../views/member/bindBank'),
    meta: {
      IsLog: false,
      showMemberNav: true,
      showFooter: true,
      showBgi: true
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if (store.state.token) {
    if (to.path !== '/login' && to.path !== '/res') {
      next()
    } else {
      router.go(-1)
    }
  } else {
    if (to.path === '/login' || to.path === '/res' || !to.meta.IsLog) {
      next()
    } else {
      router.push('/login')
    }
  }
})
export default router
